import { Injectable } from '@angular/core';
import { BootstrapSemanticVariation } from '@app/utils/bootstrap';

@Injectable({
  providedIn: 'root',
})
export class RegistrationStatusUtilsService {
  getBootstrapVariant(status: RegistrationStatus): BootstrapSemanticVariation {
    switch (status) {
      case RegistrationStatus.Blocked:
        return `danger`;
      case RegistrationStatus.Registered:
      case RegistrationStatus.PushRegistered:
        return `success`;
      case RegistrationStatus.Unregistered:
        return `warning`;
      default:
        return null;
    }
  }

  getStyle(status: RegistrationStatus, prefix: string): string {
    const variant = this.getBootstrapVariant(status);

    if (variant != null) {
      return `${prefix}${this.getBootstrapVariant(status)}`;
    } else {
      return '';
    }
  }

  getTranslatable(status: RegistrationStatus) {
    return `registrations.status.${status == null ? 'NONE' : status}`;
  }

  parse(status: string): RegistrationStatus {
    switch (status) {
      case 'blocked':
        return RegistrationStatus.Blocked;
      case 'active':
      case 'online':
      case '':
        return RegistrationStatus.Registered;
      default:
        return RegistrationStatus.Unregistered;
    }
  }
}

/**
 * Registration status of a device
 */
export enum RegistrationStatus {
  Blocked = 'BLOCKED', // device has blocked registrations
  None = 'NONE', // no registration available for this device
  PushRegistered = 'PUSH_REGISTERED', // a mobile client is unregistered, but has active push tokens
  Registered = 'REGISTERED', // device has a valid registration
  Unregistered = 'UNREGISTERED', // device is missing a registration (unregistered)
  Unknown = 'UNKNOWN', // no status available for the registration
}
